import React, { useState, useEffect, useRef } from "react";
import apiClient from "../apiClient";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaSpinner } from 'react-icons/fa';
import { useShop } from '../context/ShopContext';
import Sidebar from "./Sidebar";
import "./parchaTable.css";



const EdittransferstockdesiDate = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [date, setDate] = useState(localStorage.getItem("sip_date_desi_bhejan") || new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shopId, setShopId] = useState(null);
  const [tokenString, setToken] = useState(null);
  const [shopName, setshopName] = useState(null);

  const inputRefs = useRef([]);
  const [apiConditionMet, setApiConditionMet] = useState(null);
  const [shopOptions, setShopOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rsbclData, setRsbclData] = useState(null);
  const [transactionNo, setTransactionNo] = useState("");
  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { userId, companyId } = useShop();
  const [receiveType, setReceiveType] = useState("");
  const [selectedTypeName, setSelectedTypeName] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [shop, setShop] = useState("");
  const [partyMaster, setPartyMaster] = useState("");
  const [transferTypes, setTransferTypes] = useState([]);
  const [shops, setShops] = useState([]);
  const [partyMasters, setPartyMasters] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [remark, setRemark] = useState("");
  const [searchedProducts, setSearchedProducts] = useState([]);

  const [shopCodes, setShopCodes] = useState([]);
  const [selectedShopCode, setSelectedShopCode] = useState("");

  const [catFilter, setCatFilter] = useState("");
  const [showEnteredOnly, setShowEnteredOnly] = useState(false);

  /* ── Mobile-only state ── */
  const [expandedCats, setExpandedCats] = useState({});
  const [mobileSelectedVar, setMobileSelectedVar] = useState({});



  const showToast = (message, type = "error") => {
    toast.dismiss();
    if (type.toLowerCase() === "error") {
      toast.error(message);
    } else if (type.toLowerCase() === "success") {
      toast.success(message);
    }
  };



  useEffect(() => {
    const savedShopId = localStorage.getItem("shopId");
    const savedTokenString = localStorage.getItem("tokenString");
    const savedshopName = localStorage.getItem("shopName");
    if (savedShopId && savedTokenString && savedshopName) {
      setShopId(savedShopId);
      setToken(savedTokenString);
      setshopName(savedshopName);
    } else {
      showToast("Please log in first!", "error");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (shopId && tokenString && shopName) {
      fetchStock();
    }
  }, [shopId, tokenString, shopName, date]);


  useEffect(() => {
    if (searchQuery.trim()) {
      const filtered = products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredProducts(filtered);
      setPreviewData((prevData) => ({
        ...prevData,
        selectedProducts: filtered.filter((product) => selectedProducts.includes(product.id)),
      }));
    } else {
      setFilteredProducts(products);
      setPreviewData((prevData) => ({
        ...prevData,
        selectedProducts: products.filter((product) => selectedProducts.includes(product.id)),
      }));
    }
  }, [searchQuery, products, selectedProducts]);



  const fetchStock = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(
        "/Liquor/GetStockProductDataWithDate",
        {
          shopId,
          typeId: "2",
          stockDate: date || new Date().toISOString().split("T")[0],
        }
      );
      const fetchedProducts = response.data.data || [];
      const updatedProducts = fetchedProducts
        .filter(product => {
          const avail = (parseFloat(product.openingStock) || 0) + (parseFloat(product.receivedQty) || 0);
          return avail > 0;
        })
        .map((product) => ({
          id: product.id,
          name: product.pName,
          cat: product.catName || product.categoryName || product.typeName || "General",
          selected: false,
          variants: [
            {
              volume: product.packing,
              rate: parseFloat(product.mrp),
              openingStock: parseFloat(product.openingStock || 0),
              receivedStock: parseFloat(product.receivedQty || 0),
              transferStock: "",
              currentStock: "",
              isSubmitted: false,
            },
          ],
        }));
      setProducts(updatedProducts);
      setFilteredProducts(updatedProducts);
      setSearchedProducts(updatedProducts);
      setApiConditionMet(true);
    } catch (err) {
      setError("Error fetching stock data");
      console.error("Error fetching stock:", err);
      setApiConditionMet(false);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const fetchTransferTypes = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetTypeMst', { shopId, companyId });
        const options = response.data?.data?.map((item) => ({
          id: item.id, label: item.name, type: item.typeName, type1: item.type,
        }));
        setTransferTypes(options);
      } catch (err) {
        console.error('Error fetching dropdown options:', err);
        showToast('Failed to load dropdown options.', "error");
      }
    };
    fetchTransferTypes();
  }, []);

  useEffect(() => {
    const fetchPartyMasters = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetPartyMaster', { companyId });
        const options = response.data?.data?.map((item) => ({ id: item.id, label: item.name }));
        setPartyMasters(options);
      } catch (err) {
        console.error('Error fetching party master options:', err);
        showToast('Failed to load party masters.', "error");
      }
    };
    fetchPartyMasters();
  }, []);

  useEffect(() => {
    const fetchShopOptions = async () => {
      try {
        const response = await apiClient.post('/Liquor/GetShopMaster', { userId, companyId });
        const options = response.data?.data?.map((item) => ({ id: item.id, label: item.name }));
        setShopOptions(options);
        setIsLoading(false);
      } catch (err) {
        setError('Failed to fetch shop options');
        setIsLoading(false);
      }
    };
    fetchShopOptions();
  }, []);



  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prevSelected) => {
      if (prevSelected.includes(productId)) return prevSelected.filter(id => id !== productId);
      return [...prevSelected, productId];
    });
  };

  const handletransferStockChange = (productIndex, variantIndex, value) => {
    if (!selectedProducts.includes(filteredProducts[productIndex].id)) return;
    if (value === "") {
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].transferStock = "";
      setFilteredProducts(updatedProducts);
      return;
    }
    const numericValue = Number(value);
    if (numericValue < 0) {
      showToast("Negative values are not allowed!", "error");
      const updatedProducts = [...filteredProducts];
      updatedProducts[productIndex].variants[variantIndex].transferStock = "";
      setFilteredProducts(updatedProducts);
      return;
    }
    const updatedProducts = [...filteredProducts];
    updatedProducts[productIndex].variants[variantIndex].transferStock = numericValue;
    setFilteredProducts(updatedProducts);
  };

  /* ── Helper: sync a qty change to the master products array ── */
  const syncQtyToMaster = (productId, newQty, qtyField = "transferStock") => {
    setProducts(prev => prev.map(p =>
      p.id === productId
        ? { ...p, variants: [{ ...p.variants[0], [qtyField]: newQty }] }
        : p
    ));
  };

  /* ── Mobile stepper for transferStock ── */
  const handleMobileStepperChange = (productId, delta) => {
    const productIndex = filteredProducts.findIndex(p => p.id === productId);
    if (productIndex === -1) return;
    const product = filteredProducts[productIndex];
    const variant = product.variants[0];
    const currentQty = parseFloat(variant.transferStock || 0);
    const available = (parseFloat(variant.openingStock) || 0) + (parseFloat(variant.receivedStock) || 0);
    const newQty = Math.min(available, Math.max(0, currentQty + delta));
    // Update filtered view immediately
    const updatedFiltered = [...filteredProducts];
    updatedFiltered[productIndex] = { ...product, variants: [{ ...variant, transferStock: newQty }] };
    setFilteredProducts(updatedFiltered);
    // Sync to master so search re-filter preserves the qty
    syncQtyToMaster(productId, newQty, "transferStock");
    if (newQty > 0 && !selectedProducts.includes(productId)) {
      setSelectedProducts(prev => [...prev, productId]);
    } else if (newQty === 0 && selectedProducts.includes(productId)) {
      setSelectedProducts(prev => prev.filter(id => id !== productId));
    }
  };

  const handleMobileQtySet = (productId, value) => {
    const productIndex = filteredProducts.findIndex(p => p.id === productId);
    if (productIndex === -1) return;
    const product = filteredProducts[productIndex];
    const variant = product.variants[0];
    const available = (parseFloat(variant.openingStock) || 0) + (parseFloat(variant.receivedStock) || 0);
    const newQty = Math.min(available, Math.max(0, parseInt(value) || 0));
    // Update filtered view immediately
    const updatedFiltered = [...filteredProducts];
    updatedFiltered[productIndex] = { ...product, variants: [{ ...variant, transferStock: newQty }] };
    setFilteredProducts(updatedFiltered);
    // Sync to master so search re-filter preserves the qty
    syncQtyToMaster(productId, newQty, "transferStock");
    if (newQty > 0 && !selectedProducts.includes(productId)) {
      setSelectedProducts(prev => [...prev, productId]);
    } else if (newQty === 0 && selectedProducts.includes(productId)) {
      setSelectedProducts(prev => prev.filter(id => id !== productId));
    }
  };

  useEffect(() => {
    if (selectedTypeName === "RSBCL") {
      const fetchShopCodes = async () => {
        try {
          const response = await apiClient.post("/Liquor/GetShopCodeData", { companyId: companyId });
          if (response.data && response.data.data) {
            setShopCodes(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching shop codes:", error);
        }
      };
      fetchShopCodes();
    }
  }, [selectedTypeName]);

  const handleTrasferTypeChange = async (e) => {
    const selectedId = e.target.value;
    setReceiveType(selectedId);
    const selectedOption = transferTypes.find((option) => option.id.toString() === selectedId);
    setSelectedTypeName(selectedOption ? selectedOption.type : "");
    setInvoiceNo("");
    setShop("");
    setPartyMaster("");
    setTransactionNo("");
    setSelectedShopCode("");
    let apiType = selectedOption?.type1;
    try {
      const response = await apiClient.post(
        "/Liquor/GetTransactionNo",
        { type: apiType, companyId: companyId, typeId: "2" }
      );
      if (response.data?.code === 200 && response.data?.data) {
        setTransactionNo(response.data.data);
        showToast(`Transaction No. received!`, "success");
      } else {
        showToast("Invalid response from API!", "error");
      }
    } catch (err) {
      console.error("API Error:", err);
      showToast("Failed to fetch transaction number!", "error");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!receiveType) { showToast("Please select a Transfer Type.", "error"); return; }
      if (selectedTypeName === "RSBCL" && !selectedShopCode) {
        showToast("Shop Code is required.", "error"); return;
      }
      if (selectedTypeName === "SHOP" && !shop) { showToast("Please select a Shop.", "error"); return; }
      if (selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && !partyMaster) {
        showToast("Please select a Party Master.", "error"); return;
      }
      if (selectedProducts.length === 0) { showToast("Please select at least one product!", "error"); return; }
      for (const product of products) {
        if (selectedProducts.includes(product.id)) {
          let hasValidStock = product.variants.some((variant) => Number(variant.transferStock || 0) > 0);
          if (!hasValidStock) { showToast(`Please enter Transfer stock for ${product.name}!`, "error"); return; }
        }
      }
      const selectedData = products
        .filter((product) => selectedProducts.includes(product.id))
        .map((product) => ({
          ProductId: product.id,
          transferHeadQty: product.variants.reduce((total, variant) => total + Number(variant.transferStock || 0), 0),
        }));
      const finalInvoiceNo = invoiceNo?.trim() || "0";
      const finalPartyMaster = partyMaster || "0";
      const finalShop = shop || "0";
      const payload = {
        transferHeadId: receiveType,
        transferPartyId: finalPartyMaster,
        transferShopId: finalShop,
        shopId: shopId,
        StockDate: date || new Date().toISOString().split("T")[0],
        invoiceNo: finalInvoiceNo,
        Remark: remark,
        transactionNo: "0",
        transactionNumber: transactionNo,
        transferQtyDetails: selectedData,
        ShopCode: selectedShopCode || "0",
      };
      setLoading(true);
      let apiUrl = selectedTypeName === "SHOP"
        ? "/Liquor/SaveProductBulkTransferDetailsStage"
        : "/Liquor/SaveBulkProductTransferDetails";
      const response = await apiClient.post(apiUrl, payload);
      if (response.status === 200) {
        if (response.data && response.data.data === "Negative stock detected after transaction.") {
          showToast(" Negative stock detected!", "error");
        } else {
          showToast("Stock report submitted successfully!", "success");
          setSelectedProducts([]);
          setInvoiceNo("");
          setRemark("");
          setShop("");
          setPartyMaster("");
          setReceiveType("");
          setTransactionNo("");
          setSelectedTypeName("");
          setSelectedShopCode("");
          const resetProducts = products.map(p => ({
            ...p,
            variants: p.variants.map(v => ({ ...v, transferStock: "" }))
          }));
          setProducts(resetProducts);
          setFilteredProducts(resetProducts);
          fetchStock();
        }
      } else {
        showToast(`Error submitting stock report: ${response.statusText}`, "error");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      showToast(error.response?.data?.message || "Failed to submit data!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = () => {
    if (products.length === 0) { showToast("No product data available for preview!", "error"); return; }
    const editedProducts = products
      .map((product) => ({
        ...product,
        variants: product.variants.filter(variant => variant.transferStock > 0)
      }))
      .filter(product => product.variants.length > 0);
    if (editedProducts.length === 0) {
      showToast("No Products Edited!", "error");
    } else {
      setPreviewData({ selectedProducts: editedProducts });
      setShowPreview(true);
    }
  };

  /* ── Mobile helpers ── */
  const toggleCat = (cat) => setExpandedCats(prev => ({ ...prev, [cat]: prev[cat] === false ? true : false }));
  const isCatExpanded = (cat) => expandedCats[cat] !== false;

  const buildMobileGroups = () => {
    const catOrder = [];
    const catMap = new Map();
    filteredProducts.forEach(product => {
      const cat = product.cat || "General";
      if (!catMap.has(cat)) { catMap.set(cat, new Map()); catOrder.push(cat); }
      const nameMap = catMap.get(cat);
      if (!nameMap.has(product.name)) nameMap.set(product.name, []);
      nameMap.get(product.name).push(product);
    });
    return catOrder.map(cat => {
      const nameMap = catMap.get(cat);
      const groups = [];
      nameMap.forEach((prods, name) => groups.push({ name, products: prods }));
      return { cat, groups };
    });
  };

  const totalTransferQty = products.reduce(
    (s, p) => s + p.variants.reduce((vs, v) => vs + Number(v.transferStock || 0), 0), 0
  );
  const enteredCount = products.filter(p => p.variants.some(v => Number(v.transferStock || 0) > 0)).length;
  const totalTransferValue = products.reduce((s, p) => s + p.variants.reduce((vs, v) => vs + Number(v.transferStock || 0) * Number(v.rate || 0), 0), 0);

  /* ══════════════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════════════ */
  return (
    <>
      <ToastContainer />

      {/* ═══ DESKTOP LAYOUT ═══════════════════════════════ */}
      <div className="amad-desktop-content">
        <div className="amad-desk-filter-bar">
          <div className="amad-desk-filter-grid">
            <div className="amad-desk-filter-field">
              <label>Search Products</label>
              <div className="amad-desk-filter-inp-wrap">
                <span className="amad-desk-filter-ico">🔍</span>
                <input type="text" placeholder="Search by product name..."
                  value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
              </div>
            </div>
            <div className="amad-desk-filter-field">
              <label>Select Date</label>
              <input type="date" value={date} max={new Date().toISOString().split("T")[0]}
                onChange={e => { setDate(e.target.value); localStorage.setItem("sip_date_desi_bhejan", e.target.value); }} />
            </div>
            <div className="amad-desk-filter-field">
              <label>Transfer Type</label>
              <select value={receiveType} onChange={handleTrasferTypeChange}>
                <option value="">Select transfer type...</option>
                {transferTypes.filter(opt => opt.label !== "RSBCL").map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
            </div>
            {selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
              <div className="amad-desk-filter-field">
                <label>Party Master</label>
                <select value={partyMaster} onChange={e => setPartyMaster(e.target.value)}>
                  <option value="">Select party master...</option>
                  {partyMasters.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
                </select>
              </div>
            )}
            {selectedTypeName === "SHOP" && (
              <div className="amad-desk-filter-field">
                <label>Shop</label>
                <select value={shop} onChange={e => setShop(e.target.value)}>
                  <option value="">Select Shop</option>
                  {shopOptions.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
                </select>
              </div>
            )}
          </div>
          {selectedTypeName === "RSBCL" && (
            <div className="amad-desk-filter-extra">
              <div className="amad-desk-filter-field">
                <label>Shop Code</label>
                <select value={selectedShopCode} onChange={e => setSelectedShopCode(e.target.value)}>
                  <option value="">-- Select Shop Code --</option>
                  {shopCodes.map(s => <option key={s.id} value={s.licenseNameCode}>{s.licenseNameCode}</option>)}
                </select>
              </div>
            </div>
          )}
          {transactionNo && <div className="amad-desk-txn-badge">Txn: {transactionNo}</div>}
        </div>

        {apiConditionMet === true && (
          <div className="amad-desk-stat-bar">
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">{products.length}</div>
              <div className="amad-desk-stat-lbl">TOTAL PRODUCTS</div>
            </div>
            <div className="amad-desk-stat-card grn">
              <div className="amad-desk-stat-num">{enteredCount}</div>
              <div className="amad-desk-stat-lbl">ENTERED</div>
            </div>
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">{totalTransferQty}</div>
              <div className="amad-desk-stat-lbl">TOTAL QTY</div>
            </div>
            <div className="amad-desk-stat-card">
              <div className="amad-desk-stat-num">₹{totalTransferValue.toLocaleString("en-IN")}</div>
              <div className="amad-desk-stat-lbl">TOTAL VALUE</div>
            </div>
            <button className={`amad-desk-entered-btn${showEnteredOnly ? ' active' : ''}`}
              onClick={() => setShowEnteredOnly(p => !p)}>
              {showEnteredOnly ? '✅ Entered Only' : 'Show Entered Only'}
            </button>
          </div>
        )}

        <div className="amad-desk-products">
          {apiConditionMet === null && (
            <div className="amad-desk-loading"><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Loading stock data…</div>
          )}
          {apiConditionMet === false && <div className="amad-desk-empty">✅ Already Submitted Data</div>}
          {apiConditionMet === true && (() => {
            const allGroups = buildMobileGroups();
            let groups = catFilter ? allGroups.filter(g => g.cat === catFilter) : allGroups;
            if (showEnteredOnly) {
              groups = groups.map(g => ({
                ...g,
                groups: g.groups.filter(({ products: np }) => np.some(p => Number(p.variants[0]?.transferStock || 0) > 0))
              })).filter(g => g.groups.length > 0);
            }
            return (<>
              <div className="amad-desk-cat-jumper">
                <button className={`amad-desk-cat-chip${!catFilter ? ' active' : ''}`} onClick={() => setCatFilter("")}>ALL <span className="amad-desk-cat-chip-count">{allGroups.reduce((s,g)=>s+g.groups.length,0)}</span></button>
                {allGroups.map(g => <button key={g.cat} className={`amad-desk-cat-chip${catFilter===g.cat?' active':''}`} onClick={() => setCatFilter(p=>p===g.cat?'':g.cat)}>{g.cat} <span className="amad-desk-cat-chip-count">{g.groups.length}</span></button>)}
              </div>
              {groups.length === 0
                ? <div className="amad-desk-empty" style={{color:"#6B7280"}}>No products found</div>
                : groups.map(({ cat, groups: nameGroups }) => {
              const expanded = isCatExpanded(cat);
              return (
                <div key={cat} className="amad-desk-cat-section">
                  <div className="amad-desk-cat-hdr" onClick={() => toggleCat(cat)}>
                    <div className="amad-desk-cat-hdr-left">
                      <span className="amad-desk-cat-name">{cat}</span>
                      <span className="amad-desk-cat-badge">{nameGroups.length} products</span>
                    </div>
                    <div className="amad-desk-cat-hdr-stats">
                      <span>CATEGORY QTY: <strong>{nameGroups.reduce((s, {products: np}) => s + np.reduce((ps, p) => ps + Number(p.variants[0]?.transferStock || 0), 0), 0)}</strong></span>
                      <span>CATEGORY VALUE: <strong>₹{nameGroups.reduce((s, {products: np}) => s + np.reduce((ps, p) => { const v = p.variants[0]; return ps + Number(v?.transferStock || 0) * Number(v?.rate || 0); }, 0), 0).toLocaleString("en-IN")}</strong></span>
                    </div>
                    <span className="amad-desk-cat-arrow">{expanded ? '▲' : '▼'}</span>
                  </div>
                  {expanded && (
                    <div className="amad-desk-cards-grid">
                      {nameGroups.map(({ name, products: nameProds }) => {
                        const hasAnyQty = nameProds.some(p => Number(p.variants[0]?.transferStock || 0) > 0);
                        const bottleProds = nameProds.filter(p => !p.variants[0].volume.toUpperCase().includes('PET'));
                        const petProds = nameProds.filter(p => p.variants[0].volume.toUpperCase().includes('PET'));
                        return (
                          <div key={name} className={`amad-desk-product-card${hasAnyQty ? ' selected' : ''}`}>
                            <div className="amad-desk-card-toprow">
                              <span className="amad-desk-card-dot" />
                              <span className="amad-desk-card-pname2">{name}</span>
                              <span className="amad-desk-card-vbadge">{nameProds.length}v</span>
                            </div>
                            <div className="amad-desk-tbl-hdr">
                              <span className="amad-tdh amad-tdh-var">VARIANT</span>
                              <span className="amad-tdh amad-tdh-rate">RATE</span>
                              <span className="amad-tdh amad-tdh-stk">STOCK</span>
                              <span className="amad-tdh amad-tdh-qty">TRANSFER</span>
                            </div>
                            {bottleProds.length > 0 && (<>
                              <div className="amad-desk-sec-lbl">BOTTLE</div>
                              {bottleProds.map(p => {
                                const v = p.variants[0];
                                const rowQty = Number(v.transferStock || 0);
                                return (
                                  <div key={p.id} className={`amad-desk-tbl-row${rowQty > 0 ? ' has-qty' : ''}`}>
                                    <span className="amad-tdc amad-tdc-var">{v.volume}</span>
                                    <span className="amad-tdc amad-tdc-rate">₹{Number(v.rate || 0).toLocaleString("en-IN")}</span>
                                    <span className="amad-tdc amad-tdc-stk">{v.openingStock + (v.receivedStock || 0)}</span>
                                    <input type="number" inputMode="numeric" min="0"
                                      className="amad-tdc amad-tdc-inp"
                                      value={rowQty === 0 ? '' : rowQty} placeholder="0"
                                      onChange={e => handleMobileQtySet(p.id, e.target.value)}
                                      onBlur={e => { if (e.target.value === '') handleMobileQtySet(p.id, 0); }} />
                                  </div>
                                );
                              })}
                            </>)}
                            {petProds.length > 0 && (<>
                              <div className="amad-desk-sec-lbl pet">PET</div>
                              {petProds.map(p => {
                                const v = p.variants[0];
                                const rowQty = Number(v.transferStock || 0);
                                return (
                                  <div key={p.id} className={`amad-desk-tbl-row${rowQty > 0 ? ' has-qty' : ''}`}>
                                    <span className="amad-tdc amad-tdc-var">{v.volume}</span>
                                    <span className="amad-tdc amad-tdc-rate">₹{Number(v.rate || 0).toLocaleString("en-IN")}</span>
                                    <span className="amad-tdc amad-tdc-stk">{v.openingStock + (v.receivedStock || 0)}</span>
                                    <input type="number" inputMode="numeric" min="0"
                                      className="amad-tdc amad-tdc-inp"
                                      value={rowQty === 0 ? '' : rowQty} placeholder="0"
                                      onChange={e => handleMobileQtySet(p.id, e.target.value)}
                                      onBlur={e => { if (e.target.value === '') handleMobileQtySet(p.id, 0); }} />
                                  </div>
                                );
                              })}
                            </>)}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
            </>);
          })()}
        </div>

        <div className="amad-desk-footer">
          <div className="amad-desk-footer-stats">
            <span>SELECTED: <strong>{selectedProducts.length}</strong></span>
            <span className="amad-desk-footer-sep">|</span>
            <span>TOTAL QTY: <strong>{totalTransferQty}</strong></span>
            <span className="amad-desk-footer-sep">|</span>
            <span>TOTAL VALUE: <strong>₹{totalTransferValue.toLocaleString("en-IN")}</strong></span>
          </div>
          <div className="amad-desk-footer-actions">
            <button className="amad-desk-preview-btn" onClick={handlePreview}>Preview</button>
            <button className="amad-desk-submit-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? <><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Submitting…</> : "Submit Report"}
            </button>
          </div>
        </div>
      </div>
      {/* ═══ MOBILE LAYOUT ════════════════════════════════ */}
      <div className="amad-mobile">
        {/* Header */}
        <div className="amad-mobile-header">
          <div className="amad-mobile-title">देशी भेजान</div>
          <div className="amad-mobile-subtitle">Desi Stock Outward / Transfer Entry</div>
          {transactionNo && <div className="amad-mobile-txn">Txn: {transactionNo}</div>}
        </div>

        {/* Filters */}
        <div className="amad-filters">
          <div className="amad-filter-field">
            <label>Search Products</label>
            <div className="amad-filter-inp-wrap">
              <span className="amad-filter-ico">🔍</span>
              <input type="text" placeholder="Search by product name..."
                value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
            </div>
          </div>

          <div className="amad-filter-field">
            <label>Select Date</label>
            <div className="amad-filter-inp-wrap">
              <span className="amad-filter-ico">📅</span>
              <input type="date" value={date} max={new Date().toISOString().split("T")[0]}
                onChange={e => setDate(e.target.value)} />
            </div>
          </div>

          <div className="amad-filter-field">
            <label>Transfer Type</label>
            <select value={receiveType} onChange={handleTrasferTypeChange}>
              <option value="">Select transfer type...</option>
              {transferTypes.filter(opt => opt.label !== "RSBCL").map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
            </select>
          </div>

          {selectedTypeName === "RSBCL" && (
            <div className="amad-filter-field amad-filter-full">
              <label>Shop Code</label>
              <select value={selectedShopCode} onChange={e => setSelectedShopCode(e.target.value)}>
                <option value="">-- Select Shop Code --</option>
                {shopCodes.map(s => <option key={s.id} value={s.licenseNameCode}>{s.licenseNameCode}</option>)}
              </select>
            </div>
          )}

          {selectedTypeName === "SHOP" && (
            <div className="amad-filter-field amad-filter-full">
              <label>Shop</label>
              <select value={shop} onChange={e => setShop(e.target.value)}>
                <option value="">Select Shop</option>
                {shopOptions.map(opt => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
              </select>
            </div>
          )}

          {selectedTypeName !== "RSBCL" && selectedTypeName !== "SHOP" && (
            <div className="amad-filter-field">
              <label>Party Master</label>
              <select value={partyMaster} onChange={e => setPartyMaster(e.target.value)}>
                <option value="">Select party master...</option>
                {partyMasters.map(p => <option key={p.id} value={p.id}>{p.label}</option>)}
              </select>
            </div>
          )}
        </div>

        {/* Products area */}
        <div className="amad-products-area">
          {apiConditionMet === null && (
            <div className="amad-loading">
              <FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Loading stock data…
            </div>
          )}
          {apiConditionMet === false && <div className="amad-submitted">✅ Already Submitted Data</div>}
          {apiConditionMet === true && (() => {
            const allGroups = buildMobileGroups();
            const mobileGroups = catFilter ? allGroups.filter(g => g.cat === catFilter) : allGroups;
            return (<>
              <div className="amad-cat-jumper">
                <button className={`amad-cat-chip${!catFilter?' active':''}`} onClick={() => setCatFilter("")}>ALL <span className="amad-cat-chip-count">{allGroups.reduce((s,g)=>s+g.groups.length,0)}</span></button>
                {allGroups.map(g => <button key={g.cat} className={`amad-cat-chip${catFilter===g.cat?' active':''}`} onClick={() => setCatFilter(p=>p===g.cat?'':g.cat)}>{g.cat} <span className="amad-cat-chip-count">{g.groups.length}</span></button>)}
              </div>
              {mobileGroups.length === 0
                ? <div className="amad-submitted" style={{ color: "#6B7280" }}>No products found</div>
                : mobileGroups.map(({ cat, groups: nameGroups }) => {
              const expanded = isCatExpanded(cat);
              return (
                <div key={cat} className="amad-cat-section">
                  <div className="amad-cat-hdr" onClick={() => toggleCat(cat)}>
                    <div className="amad-cat-hdr-left">
                      <span className="amad-cat-name">{cat}</span>
                      <span className="amad-cat-badge">{nameGroups.length}</span>
                    </div>
                    <span className="amad-cat-arrow">{expanded ? '▲' : '▼'}</span>
                  </div>
                  {expanded && (
                    <div className="amad-cards-grid">
                    {nameGroups.map(({ name, products: nameProds }) => {
                    const hasAnyQty = nameProds.some(p => Number(p.variants[0]?.transferStock || 0) > 0);
                    const bottleProds = nameProds.filter(p => !p.variants[0].volume.toUpperCase().includes('PET'));
                    const petProds = nameProds.filter(p => p.variants[0].volume.toUpperCase().includes('PET'));
                    const renderRows = plist => plist.map(p => {
                      const v = p.variants[0]; const trnf = Number(v.transferStock || 0);
                      const avail = v.openingStock + Number(v.receivedStock || 0);
                      return (
                        <div key={p.id} className="bx-row">
                          <span className="bx-col-var">{v.volume}</span>
                          <span className="bx-col">₹{Number(v.rate||0).toLocaleString('en-IN')}</span>
                          <span className="bx-col">{avail}</span>
                          <span className="bx-col-recv"><input type="number" min="0" max={avail} value={trnf===0?'':trnf} placeholder="0" onChange={e=>handleMobileQtySet(p.id,e.target.value)} className={`bx-inp${trnf>0?" on":""}`}/></span>
                        </div>
                      );
                    });
                    return (
                      <div key={name} className="bx-card">
                        <div className="bx-card-hdr">
                          <span className="bx-card-name"><span className={`bx-dot${hasAnyQty?" on":""}`}/>{name}</span>
                          <span className="bx-vcount">{nameProds.length}v</span>
                        </div>
                        <div className="bx-th-row">
                          <span className="bx-th">VARIANT</span>
                          <span className="bx-th" style={{textAlign:"center"}}>RATE</span>
                          <span className="bx-th" style={{textAlign:"center"}}>AVAIL</span>
                          <span className="bx-th" style={{textAlign:"right"}}>TRANSFER</span>
                        </div>
                        {bottleProds.length>0 && <><div className="bx-sect bottle">BOTTLE</div>{renderRows(bottleProds)}</>}
                        {petProds.length>0 && <><div className="bx-sect pet">PET</div>{renderRows(petProds)}</>}
                        <div className="bx-footer">
                          <span>Total Transfer: <strong>{nameProds.reduce((s,p)=>s+Number(p.variants[0]?.transferStock||0),0)}</strong></span>
                        </div>
                      </div>
                    );
                    })}
                    </div>
                  )}
                </div>
              );
            })}
            </>);
          })()}
        </div>

        {/* Sticky footer */}
        <div className="amad-sticky-footer">
          <div className="amad-footer-stats">
            <span>SELECTED ITEMS: <strong>{selectedProducts.length}</strong></span>
            <span>TOTAL TRANSFER QTY: <strong>{totalTransferQty}</strong></span>
          </div>
          <div className="amad-footer-actions">
            <button className="amad-preview-btn" onClick={handlePreview}>
              Preview
            </button>
            <button className="amad-submit-btn" onClick={handleSubmit} disabled={loading}>
              {loading ? <><FaSpinner style={{ animation: "spin 1s linear infinite" }} /> Submitting…</> : "Submit Report"}
            </button>
          </div>
        </div>
      </div>

      {/* ═══ PREVIEW MODAL (React-controlled, category-wise) ══════════════════════ */}
      {showPreview && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(0,0,0,0.55)", backdropFilter: "blur(3px)",
          display: "flex", alignItems: "flex-start", justifyContent: "center",
          padding: "16px 12px", overflowY: "auto"
        }} onClick={e => { if (e.target === e.currentTarget) setShowPreview(false); }}>
          <div style={{
            background: "#fff", borderRadius: 14, width: "100%", maxWidth: "min(95vw, 680px)",
            boxShadow: "0 24px 64px rgba(0,0,0,0.28)", display: "flex", flexDirection: "column",
            maxHeight: "calc(100vh - 32px)"
          }}>
            <div style={{
              padding: "14px 18px", borderBottom: "1px solid #E5E7EB",
              display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0
            }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: "#6D214F" }}>Preview — देशी भेजान</div>
                <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>
                  {(previewData?.selectedProducts || []).reduce((t, p) => t + p.variants.filter(v => v.transferStock > 0).length, 0)} items selected
                </div>
              </div>
              <button onClick={() => setShowPreview(false)} style={{
                background: "#F3F4F6", border: "1px solid #E5E7EB", borderRadius: 8,
                padding: "8px 18px", fontSize: 13, fontWeight: 700, cursor: "pointer", color: "#374151",
                minWidth: 80, minHeight: 40
              }}>✕ Close</button>
            </div>
            <div style={{ flex: 1, overflowY: "auto", padding: "12px 16px 20px" }}>
              {(() => {
                const products = (previewData?.selectedProducts || [])
                  .map(p => ({ ...p, variants: p.variants.filter(v => v.transferStock > 0) }))
                  .filter(p => p.variants.length > 0);
                const catMap = new Map();
                products.forEach(p => {
                  const cat = p.cat || "General";
                  if (!catMap.has(cat)) catMap.set(cat, []);
                  catMap.get(cat).push(p);
                });
                return [...catMap.entries()].map(([cat, prods]) => (
                  <div key={cat} style={{ marginBottom: 16 }}>
                    <div style={{
                      fontSize: 10, fontWeight: 800, color: "#6D214F", textTransform: "uppercase",
                      letterSpacing: 1.5, padding: "5px 10px", background: "#FDF4F8",
                      borderRadius: 6, marginBottom: 6, display: "inline-block"
                    }}>{cat}</div>
                    {prods.map((product, pi) =>
                      product.variants.map((variant, vi) => (
                        <div key={`${pi}-${vi}`} style={{
                          display: "flex", justifyContent: "space-between", alignItems: "center",
                          padding: "10px 12px", borderBottom: "1px solid #F3F4F6"
                        }}>
                          <div style={{ flex: 1, minWidth: 0, paddingRight: 12 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: "#111827",
                              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {product.name}
                            </div>
                            <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 2 }}>
                              {variant.volume} &nbsp;·&nbsp; ₹{variant.rate}
                            </div>
                          </div>
                          <div style={{
                            background: "#FFF7ED", color: "#C2410C", borderRadius: 20,
                            padding: "4px 14px", fontSize: 15, fontWeight: 800, flexShrink: 0
                          }}>{variant.transferStock}</div>
                        </div>
                      ))
                    )}
                  </div>
                ));
              })()}
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
    </>
  );
};

export default EdittransferstockdesiDate;
